(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/date-input/assets/javascripts/components/date-input.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/date-input/assets/javascripts/components/date-input.trinidad.js');
"use strict";

(() => {
  "use strict";

  const __webpack_require__ = {};
  __webpack_require__.n = module => {
const getter = module && module.__esModule ? () => module['default'] : () => module;
    __webpack_require__.d(getter, {
      a: getter
    });
    return getter;
  };
  __webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
          enumerable: true,
          get: definition[key]
        });
      }
    }
  };
  __webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  let __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => (date_input)
  });
  ; 
  const external_PropTypes_namespaceObject = window["PropTypes"];
  var external_PropTypes_default = __webpack_require__.n(external_PropTypes_namespaceObject);
  ; 
  const external_svs_ui_ReactForm_namespaceObject = window["svs"]["ui"]["ReactForm"];
  ; 
  const _excluded = ["errorMessageDefault", "errorMessageRequired", "helpMessage", "hasTime", "infoMessage", "isRequired", "label", "max", "min", "name", "isLessSpace", "onBlur", "onChange", "onFocus", "value"];
  function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }, _extends.apply(null, arguments);
  }
  function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o,
      r,
      i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
  }
  function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
      if (-1 !== e.indexOf(n)) continue;
      t[n] = r[n];
    }
    return t;
  }

  ;
  const DateInput = _ref => {
    let errorMessageDefault = _ref.errorMessageDefault,
      errorMessageRequired = _ref.errorMessageRequired,
      helpMessage = _ref.helpMessage,
      hasTime = _ref.hasTime,
      infoMessage = _ref.infoMessage,
      isRequired = _ref.isRequired,
      label = _ref.label,
      max = _ref.max,
      min = _ref.min,
      name = _ref.name,
      isLessSpace = _ref.isLessSpace,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, _excluded);
    const validateDate = date => /^(\d{2}|\d{4})-\d{2}-\d{2}$/.test(date);
    const validateDateTime = date => /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(date);
    const validate = (event, value) => {
      const isValidDate = hasTime ? validateDateTime(value) : validateDate(value);
      const hasValue = value.length > 0;
      let isValid = hasValue && isValidDate;
      let currentErrorMessage = '';
      if (event === 'onSubmit' && isRequired && !hasValue) {
        currentErrorMessage = errorMessageRequired;
      } else if (!isValidDate) {
        currentErrorMessage = errorMessageDefault;
      }
      if (event === 'onBlur' || !isRequired) {
        isValid = isValidDate;
        if (value === '') {
          isValid = true;
          currentErrorMessage = '';
        }
      }
      return {
        errorMessage: currentErrorMessage,
        isValid,
        name
      };
    };
    return React.createElement(external_svs_ui_ReactForm_namespaceObject.FormContext.Consumer, null, _ref2 => {
      let form = _ref2.form,
        handleBlur = _ref2.handleBlur,
        handleChange = _ref2.handleChange,
        handleFocus = _ref2.handleFocus,
        register = _ref2.register;
      return React.createElement(external_svs_ui_ReactForm_namespaceObject.ControlGroup, {
        errorMessage: form[name] && form[name].errorMessage,
        hasError: form[name] && !form[name].isValid,
        infoMessage: infoMessage,
        isLessSpace: isLessSpace,
        v2: true
      }, React.createElement(external_svs_ui_ReactForm_namespaceObject.Inputv2, _extends({
        autoCapitalize: "off",
        autoComplete: "email",
        autoCorrect: "off",
        inputHelpText: helpMessage,
        label: label,
        max: max,
        min: min,
        name: name,
        onBlur: e => {
          handleBlur(e, onBlur);
        },
        onChange: e => {
          handleChange(e, onChange);
        },
        onFocus: e => {
          handleFocus(e, onFocus);
        },
        refElem: register(name, validate),
        spellCheck: "false",
        type: hasTime ? 'datetime-local' : 'date',
        value: value
      }, props)));
    });
  };
  DateInput.defaultProps = {
    errorMessageDefault: 'Du måste ange ett datum i formatet åååå-mm-dd',
    errorMessageRequired: 'Du måste ange ett datum',
    hasTime: false,
    helpMessage: 'ÅÅÅÅ-MM-DD',
    isRequired: true,
    label: 'Datum'
  };
  DateInput.__docgenInfo = {
    "description": "",
    "methods": [],
    "displayName": "DateInput",
    "props": {
      "errorMessageDefault": {
        "defaultValue": {
          "value": "'Du m\xE5ste ange ett datum i formatet \xE5\xE5\xE5\xE5-mm-dd'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "errorMessageRequired": {
        "defaultValue": {
          "value": "'Du m\xE5ste ange ett datum'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "hasTime": {
        "defaultValue": {
          "value": "false",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "helpMessage": {
        "defaultValue": {
          "value": "'\xC5\xC5\xC5\xC5-MM-DD'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "isRequired": {
        "defaultValue": {
          "value": "true",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "label": {
        "defaultValue": {
          "value": "'Datum'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "infoMessage": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "isLessSpace": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "max": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "min": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "name": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": true
      },
      "onBlur": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": false
      },
      "onChange": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": true
      },
      "onFocus": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": false
      },
      "value": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": true
      }
    }
  };
  const date_input = DateInput;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactFormInputs = window.svs.ui.ReactFormInputs || {}).DateInput = __webpack_exports__["default"];
})();

 })(window);